export default defineNuxtRouteMiddleware(async (to) => {
    const {$auth} = useNuxtApp()
    if (to.path.includes('/token')) {
        const user = (await $auth.signinCallback()) as any
        return navigateTo(user.state?.path ?? '/store')
    }
    const user = await $auth.getUser()
    if (user === null || user.expired) {
        await $auth.signinRedirect({state: {path: to.fullPath}})
        return navigateTo('/store')
    }
})